import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  CONTENT: '[data-fragment="ProductCategorySliderSticky.content"]',
  SLIDER: '[data-fragment="ProductCategorySliderSticky.slider"]',
  REFERENCE: '[data-fragment="ProductCategorySliderSticky.reference"]',
};

class ProductCategorySliderSticky extends WebComponent {
  constructor(props) {
    super(props);

  }
  didMount() {
    const {
      stickyClass,
      stayBottomClass,
    } = this.props;

    this.content = this.element.querySelector(fragments.CONTENT);
    this.slider = this.element.querySelector(fragments.SLIDER);
    this.reference = this.element.querySelector(fragments.REFERENCE);

    document.addEventListener('scroll', () => {
      if(this.content.getBoundingClientRect().top < 0 && this.reference.getBoundingClientRect().top > 720) {
          this.slider.classList.add(stickyClass);
      } else {
          this.slider.classList.remove(stickyClass);
      }
      if(this.reference.getBoundingClientRect().top <= 720) {
          this.slider.classList.add(stayBottomClass);
      } else {
          this.slider.classList.remove(stayBottomClass);
      }
    });

  }

}

ProductCategorySliderSticky.defaultProps = {
  stickyClass: 'category-product-slider--sticky',
  stayBottomClass: 'category-product-slider--stay-bottom',
};

export default ProductCategorySliderSticky;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ProductCategorySliderSticky.js